import { decodeBase64 } from "../utils/functions.js";
//#region src/modules/core/data/query.ts
var fetchCore = async (instance) => {
	return (await instance.get("/api")).data;
};
var fetchNotifications = async (instance) => {
	return (await instance.get("/api/notification")).data;
};
var fetchMenu = async (instance) => {
	return (await instance.get("/api/menu")).data;
};
var fetchUser = async (instance) => {
	const response = await instance.get("/api/user/me");
	return {
		...response.data,
		avatarLink: decodeBase64(response.data.avatarLink)
	};
};
//#endregion
export { fetchCore, fetchMenu, fetchNotifications, fetchUser };
